import { checkSupplierLimit } from 'api/shop';
import { ShopPageType } from 'libs/enums';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

type TradeConstraintTipProps = {
  shopData: any;
};
export default function TradeConstraintTip({ shopData }: TradeConstraintTipProps) {
  const [show, setShow] = useState(false);
  const router = useRouter();

  useEffect(() => {
    initData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopData.type]);

  async function initData() {
    if (shopData.type === ShopPageType.INDEX) {
      const res = await checkSupplierLimit(router.query.shopSysNo, {});
      if (res.code === 200) {
        setShow(res.data);
      }
    }
  }

  if (shopData.type !== ShopPageType.INDEX || !show) return null;
  return (
    <div className="tip-wrap">
      该供应商已被限制平台交易，您可以继续浏览店铺或商品，但不能向供应商下单。
      <style jsx>{`
        .tip-wrap {
          width: 100%;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #ffeae0;
          font-size: 14px;
          color: #f5222d;
        }
        .tip-btn {
          color: #f5222d;
        }
      `}</style>
    </div>
  );
}
